import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ImageCroppedEvent } from 'ngx-image-cropper';

interface DialogData {
  imageChangedEvent: any;
  title?: string;
}

@Component({
  selector: 'app-cropper-popup',
  templateUrl: './cropper-popup.component.html',
  styleUrls: ['./cropper-popup.component.scss'],
  standalone: false,
})
export class CropperPopupComponent {
  public croppedImage: ImageCroppedEvent | undefined;

  constructor(
    public dialogRef: MatDialogRef<CropperPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {}

  onNoClick(): void {
    this.dialogRef.close();
  }

  async imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event;
  }

  onSave(): void {
    this.dialogRef.close(this.croppedImage);
  }
}
